import React from 'react';

const Footer = () => {
    return (
        <div className='p-5 bg-dark mt-5'>
            <h5 className='text-light text-center m-5'>All copyright reserved by <span className='text-warning uppercase'>SP SUJOY</span></h5>
        </div>
    );
};

export default Footer;